export default __webpack_public_path__ + "148d248cfb957c7bacf33b720735b924.webp";